webpackJsonp([1],{

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      visible: true,
      estatisticas: {
        visible: false,
        titulo: '',
        escalonador: 'sjf',
        tempoMedioResposta: 0,
        throughput: 0,
        tempoMedioEspera: 0,
        tamMedioFilaPronto: 0
      },
      sjf: {
        status: '',
        lista_bcp: [],
        fila_bloqueado: [],
        fila_pronto: [],
        executando: '',
        max_fila_pronto: 0,
        qtd_fila_pronto: [],
        tempo_inicial: 0,
        tempo_final: 0,
        clock: 0
      },
      prio: {
        status: '',
        lista_bcp: [],
        fila_bloqueado: [],
        fila_pronto: [],
        executando: '',
        tempo_resposta: 0,
        executou: 0,
        max_fila_pronto: 0,
        qtd_fila_pronto: [],
        tempo_inicial: 0,
        tempo_final: 0,
        clock: 0
      },
      rr: {
        status: '',
        lista_bcp: [],
        fila_bloqueado: [],
        fila_pronto: [],
        executando: '',
        max_fila_pronto: 0,
        qtd_fila_pronto: [],
        tempo_inicial: 0,
        tempo_final: 0,
        clock: 0
      }
    };
  },

  methods: {
    verifica_fim: function verifica_fim(escalonador) {
      var res = true;

      this[escalonador].lista_bcp.forEach(function (bcp) {
        if (bcp['estado'] !== 'terminado') {
          res = false;
        }
      });

      if (res) {
        this[escalonador]['tempo_final'] = new Date();
        this[escalonador].status = 'terminado';
      }
      return res;
    },
    verifica_bloqueados: function verifica_bloqueados(escalonador, ordenacao) {
      var _this = this;
      var i = 0;

      while (i < _this[escalonador].fila_bloqueado.length) {
        if (_this[escalonador].clock - _this[escalonador].fila_bloqueado[i]['cheg_bloqueado'] === _this[escalonador].fila_bloqueado[i]['tempo_bloqueado']) {
          if (_this[escalonador].fila_bloqueado[i]['tempo_cpu'] === _this[escalonador].fila_bloqueado[i]['tempo_exec']) {
            _this[escalonador].fila_bloqueado[i]['estado'] = 'terminado';
          } else {
            _this[escalonador].fila_bloqueado[i]['estado'] = 'pronto';
            _this[escalonador].fila_pronto.push(_this[escalonador].fila_bloqueado[i]);
            _this[escalonador].fila_bloqueado[i]['tempo_espera'].push(_this[escalonador].clock + 1);

            if (ordenacao !== '') {
              _this[escalonador].fila_pronto.sort(function (a, b) {
                return a[ordenacao] - b[ordenacao];
              });
            }
          }

          _this[escalonador].fila_bloqueado.splice(i, 1);
          i -= 1;
        }
        i += 1;
      }
    },
    bloqueia_processo: function bloqueia_processo(escalonador, tempoChegada, tempoBloqueado, processo) {
      var _this = this;

      _this[escalonador].fila_bloqueado.push(processo);
      processo['cheg_bloqueado'] = tempoChegada;
      processo['tempo_bloqueado'] = tempoBloqueado;
      processo['estado'] = 'bloqueado';
    },
    adiciona_historico: function adiciona_historico(escalonador) {
      var _this = this;

      _this[escalonador].lista_bcp.forEach(function (bcp) {
        if (bcp['estado'] === 'pronto') {
          bcp['historico'].push('p');
        } else if (bcp['estado'] === 'bloqueado') {
          bcp['historico'].push('b');
        } else if (bcp['estado'] === 'executando') {
          bcp['historico'].push('e');
        } else {
          bcp['historico'].push('o');
        }
      });
    },
    conta_fila: function conta_fila(escalonador) {
      var qtd = this[escalonador]['fila_pronto'].length;

      this[escalonador]['qtd_fila_pronto'].push(qtd);

      if (qtd > this[escalonador]['max_fila_pronto']) {
        this[escalonador]['max_fila_pronto'] = qtd;
      }
    },
    calc_estatisticas: function calc_estatisticas(escalonador) {
      var _this = this[escalonador];

      var tempoMedioResposta = 0;
      var throughput = 0;
      var tamMedioFilaPronto = 0;
      var tempoMedioEspera = 0;
      var qtdProntos = _this['qtd_fila_pronto'].length;
      var tempoTotal = (_this['tempo_final'].getTime() - _this['tempo_inicial'].getTime()) / 1000;

      if (tempoTotal !== 0) {
        throughput = parseFloat(_this['lista_bcp'].length / (tempoTotal - this[escalonador]['clock']));
      }

      _this['qtd_fila_pronto'].forEach(function (tam) {
        tamMedioFilaPronto += tam;
      });

      if (qtdProntos !== 0) {
        tamMedioFilaPronto /= qtdProntos;
      } else {
        tamMedioFilaPronto = 0;
      }

      this[escalonador]['lista_bcp'].forEach(function (bcp) {
        tempoMedioResposta += bcp['tempo_resposta'];

        bcp['tempo_espera'].forEach(function (tempo) {
          tempoMedioEspera += tempo;
        });
      });

      tempoMedioEspera /= this[escalonador]['lista_bcp'].length;

      if (_this['lista_bcp'].length > 0) {
        tempoMedioResposta /= _this['lista_bcp'].length;
      }

      if (escalonador === 'sjf') {
        this.estatisticas['titulo'] = 'Shortest Job First';
      } else if (escalonador === 'prio') {
        this.estatisticas['titulo'] = 'Escalonador por Prioridade';
      } else {
        this.estatisticas['titulo'] = 'Round-Robin';
      }

      this.estatisticas['escalonador'] = escalonador;
      this.estatisticas['throughput'] = Math.round(throughput * 100) / 100;
      this.estatisticas['tempoMedioEspera'] = Math.round(tempoMedioEspera * 100) / 100;
      this.estatisticas['tempoMedioResposta'] = Math.round(tempoMedioResposta * 100) / 100;
      this.estatisticas['tamMedioFilaPronto'] = tamMedioFilaPronto;
      this.estatisticas['visible'] = true;
    },
    inicia: function inicia(escalonador) {
      if (this[escalonador].status === '') {
        this[escalonador]['tempo_inicial'] = new Date();
      }

      this[escalonador].status = 'continua';

      if (escalonador === 'sjf') {
        this.escalonador_sjf();
      } else if (escalonador === 'prio') {
        this.escalonador_prio();
      } else {
        this.escalonador_rr();
      }
    },
    pausa: function pausa(escalonador) {
      this[escalonador].status = 'pausado';
    },
    escalonador_sjf: function escalonador_sjf() {
      var _this = this;

      if (_this.sjf.clock % 5 === 0 && _this.sjf.clock !== 0) {
        _this.conta_fila('sjf');
      }

      if (_this.verifica_fim('sjf') || _this.sjf.status === 'pausado') {
        return 1;
      }

      _this.sjf.lista_bcp.forEach(function (bcp, index) {
        if (bcp['tempo_cheg'] === _this.sjf.clock) {
          bcp['estado'] = 'pronto';

          _this.sjf.fila_pronto.push(bcp);

          _this.sjf.fila_pronto.sort(function (a, b) {
            return a['tempo_cpu'] - b['tempo_cpu'];
          });
        }
      });

      if (_this.sjf.executando === '' & _this.sjf.fila_pronto.length > 0) {
        _this.sjf.executando = _this.sjf.fila_pronto[0];
        _this.sjf.executando['estado'] = 'executando';

        _this.sjf.executando['tempo_espera'][_this.sjf.executando['tempo_espera'].length - 1] = _this.sjf.clock - _this.sjf.executando['tempo_espera'][_this.sjf.executando['tempo_espera'].length - 1];
        if (_this.sjf.executando['executou'] === 0) {
          _this.sjf.executando['executou'] = 1;
          _this.sjf.executando['tempo_resposta'] = _this.sjf.clock - _this.sjf.executando['tempo_cheg'];
        }

        _this.sjf.fila_pronto.shift();
      }

      _this.adiciona_historico('sjf');

      if (_this.sjf.executando !== '') {
        _this.sjf.executando['tempo_exec'] += 1;

        if (_this.sjf.executando['fila_io'].length > 0 && _this.sjf.executando['tempo_exec'] === _this.sjf.executando['fila_io'][0]) {
          _this.sjf.executando['fila_io'].shift();
          _this.bloqueia_processo('sjf', _this.sjf.clock, Math.floor(Math.random() * 9 + 1), _this.sjf.executando);

          _this.sjf.executando = '';
        } else if (_this.sjf.executando['tempo_exec'] === _this.sjf.executando['tempo_cpu']) {
          _this.sjf.executando['estado'] = 'terminado';
          _this.sjf.executando = '';
        }
      }

      _this.verifica_bloqueados('sjf', 'tempo_cpu');

      _this.sjf.clock += 1;

      setTimeout(function () {
        _this.escalonador_sjf();
      }, 1000);
    },
    escalonador_prio: function escalonador_prio() {
      var _this = this;

      if (_this.prio.clock % 5 === 0 && _this.prio.clock !== 0) {
        _this.conta_fila('prio');
      }

      if (_this.verifica_fim('prio') || _this.prio.status === 'pausado') {
        return 1;
      }

      _this.prio.lista_bcp.forEach(function (bcp, index) {
        if (bcp['tempo_cheg'] === _this.prio.clock) {
          bcp['estado'] = 'pronto';

          _this.prio.fila_pronto.push(bcp);

          _this.prio.fila_pronto.sort(function (a, b) {
            return a['prioridade'] - b['prioridade'];
          });
        }
      });

      if (_this.prio.fila_pronto.length > 0) {
        if (_this.prio.executando !== '') {
          if (_this.prio.executando['prioridade'] > _this.prio.fila_pronto[0]['prioridade']) {
            _this.prio.executando['estado'] = 'pronto';
            _this.prio.executando['tempo_espera'][_this.prio.executando['tempo_espera'].length - 1] = _this.prio.clock + 1;

            _this.prio.fila_pronto.push(_this.prio.executando);
            _this.prio.fila_pronto.sort(function (a, b) {
              return a['prioridade'] - b['prioridade'];
            });

            _this.prio.executando = _this.prio.fila_pronto[0];
            _this.prio.executando['estado'] = 'executando';

            _this.prio.executando['tempo_espera'][_this.prio.executando['tempo_espera'].length - 1] = _this.prio.clock - _this.prio.executando['tempo_espera'][_this.prio.executando['tempo_espera'].length - 1];

            _this.prio.fila_pronto.pop(0);
          }
        } else if (_this.prio.executando === '') {
          _this.prio.executando = _this.prio.fila_pronto[0];
          _this.prio.executando['estado'] = 'executando';

          _this.prio.executando['tempo_espera'][_this.prio.executando['tempo_espera'].length - 1] = _this.prio.clock - _this.prio.executando['tempo_espera'][_this.prio.executando['tempo_espera'].length - 1];

          _this.prio.fila_pronto.shift();
        }

        if (_this.prio.executando['executou'] === 0) {
          _this.prio.executando['executou'] = 1;
          _this.prio.executando['tempo_resposta'] = _this.prio.clock - _this.prio.executando['tempo_cheg'];
        }
      }

      _this.adiciona_historico('prio');

      if (_this.prio.executando !== '') {
        _this.prio.executando['tempo_exec'] += 1;

        if (_this.prio.executando['fila_io'].length > 0 && _this.prio.executando['tempo_exec'] === _this.prio.executando['fila_io'][0]) {
          _this.prio.executando['fila_io'].shift();
          _this.bloqueia_processo('prio', _this.prio.clock, Math.floor(Math.random() * 9 + 1), _this.prio.executando);
          _this.prio.executando = '';
        } else if (_this.prio.executando['tempo_exec'] === _this.prio.executando['tempo_cpu']) {
          _this.prio.executando['estado'] = 'terminado';
          _this.prio.executando = '';
        }
      }

      _this.verifica_bloqueados('prio', 'prioridade');

      _this.prio.clock += 1;

      setTimeout(function () {
        _this.escalonador_prio();
      }, 1000);
    },
    escalonador_rr: function escalonador_rr() {
      var _this = this;

      if (_this.rr.clock % 5 === 0 && _this.rr.clock !== 0) {
        _this.conta_fila('rr');
      }

      if (_this.verifica_fim('rr') || _this.rr.status === 'pausado') {
        return 1;
      }

      _this.rr.lista_bcp.forEach(function (bcp, index) {
        if (bcp['tempo_cheg'] === _this.rr.clock) {
          bcp['estado'] = 'pronto';
          _this.rr.fila_pronto.push(bcp);
        }
      });

      if (_this.rr.executando === '' && _this.rr.fila_pronto.length > 0) {
        _this.rr.executando = _this.rr.fila_pronto[0];
        _this.rr.executando['estado'] = 'executando';
        _this.rr.executando['tempo_espera'][_this.rr.executando['tempo_espera'].length - 1] = _this.rr.clock - _this.rr.executando['tempo_espera'][_this.rr.executando['tempo_espera'].length - 1];

        if (_this.rr.executando['executou'] === 0) {
          _this.rr.executando['executou'] = 1;
          _this.rr.executando['tempo_resposta'] = _this.rr.clock - _this.rr.executando['tempo_cheg'];
        }

        _this.rr.fila_pronto.shift();
      }

      _this.adiciona_historico('rr');

      if (_this.rr.executando !== '') {
        _this.rr.executando['tempo_exec'] += 1;
        _this.rr.executando['quantum'] += 1;

        if (_this.rr.executando['fila_io'].length > 0 && _this.rr.executando['tempo_exec'] === _this.rr.executando['fila_io'][0]) {
          _this.rr.executando['fila_io'].shift();
          _this.rr.executando['quantum'] = 0;
          this.bloqueia_processo('rr', _this.rr.clock, Math.floor(Math.random() * 9 + 1), _this.rr.executando);
          _this.rr.executando = '';
        } else if (_this.rr.executando['tempo_exec'] === _this.rr.executando['tempo_cpu']) {
          _this.rr.executando['estado'] = 'terminado';
          _this.rr.executando = '';
        } else if (_this.rr.executando['quantum'] === _this.rr.quantum) {
          _this.rr.fila_pronto.push(_this.rr.executando);
          _this.rr.executando['quantum'] = 0;
          _this.rr.executando['estado'] = 'pronto';
          _this.rr.executando['tempo_espera'][_this.rr.executando['tempo_espera'].length - 1] = _this.rr.clock + 1;

          _this.rr.executando = '';
        }
      }

      _this.verifica_bloqueados('rr', '');

      _this.rr.clock += 1;

      setTimeout(function () {
        _this.escalonador_rr();
      }, 1000);
    },
    addProcessos: function addProcessos() {
      var _this2 = this;

      var _this = this;

      this.form.validateFields(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(err, values) {
          var proc;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!err) {
                    _this.sjf.quantum = parseInt(values.quantum);
                    _this.prio.quantum = parseInt(values.quantum);
                    _this.rr.quantum = parseInt(values.quantum);

                    proc = values.arquivo.split('\n');

                    proc.forEach(function (p) {
                      var aux = p.split(' ').map(Number);

                      _this.sjf.lista_bcp.push({
                        'id': aux[0],
                        'tempo_cpu': aux[1],
                        'prioridade': aux[2],
                        'tempo_cheg': aux[3],
                        'fila_io': aux.slice(4, aux.length),
                        'tempo_exec': 0,
                        'estado': '',
                        'cheg_bloqueado': 0,
                        'tempo_bloqueado': 0,
                        'tempo_espera': [aux[3]],
                        'tempo_resposta': 0,
                        'executou': 0,
                        'quantum': 0,
                        'historico': []
                      });

                      _this.prio.lista_bcp.push({
                        'id': aux[0],
                        'tempo_cpu': aux[1],
                        'prioridade': aux[2],
                        'tempo_cheg': aux[3],
                        'fila_io': aux.slice(4, aux.length),
                        'tempo_exec': 0,
                        'estado': '',
                        'cheg_bloqueado': 0,
                        'tempo_bloqueado': 0,
                        'tempo_espera': [aux[3]],
                        'tempo_resposta': 0,
                        'executou': 0,
                        'quantum': 0,
                        'historico': []
                      });

                      _this.rr.lista_bcp.push({
                        'id': aux[0],
                        'tempo_cpu': aux[1],
                        'prioridade': aux[2],
                        'tempo_cheg': aux[3],
                        'fila_io': aux.slice(4, aux.length),
                        'tempo_exec': 0,
                        'estado': '',
                        'cheg_bloqueado': 0,
                        'tempo_bloqueado': 0,
                        'tempo_espera': [aux[3]],
                        'tempo_resposta': 0,
                        'executou': 0,
                        'quantum': 0,
                        'historico': []
                      });
                    });

                    _this.visible = false;
                  }

                case 1:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleCancel: function handleCancel(e) {
      this.estatisticas.visible = false;
    }
  }
});

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(451);


/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__design__ = __webpack_require__(485);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

var app;

if (!app) {
  app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    data: { toggled: false },
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
  });
}

/***/ }),

/***/ 454:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a134226_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(484);
function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var normalizeComponent = __webpack_require__(458)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a134226_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 456:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',{style:({ minHeight: '100%' })},[_c('a-modal',{attrs:{"title":"Adicione os Processos:","visible":_vm.visible,"closable":false}},[_c('template',{slot:"footer"},[_c('a-button',{key:"submit",attrs:{"type":"primary"},on:{"click":_vm.addProcessos}},[_vm._v(" Adicionar ")])],1),_vm._v(" "),_c('a-form',{attrs:{"autoFormCreate":function (form) { this$1.form = form }}},[_c('a-form-item',{attrs:{"fieldDecoratorId":"arquivo","fieldDecoratorOptions":{ rules: [{ required: true, message: 'Campo Obrigatório' }] }}},[_c('a-textarea',{attrs:{"placeholder":"# ID – DF – PRI – TC – FIO","autosize":{ minRows: 3, maxRows: 6 }}})],1),_vm._v(" "),_c('a-form-item',{attrs:{"fieldDecoratorId":"quantum","fieldDecoratorOptions":{ rules: [{ required: true, message: 'Campo Obrigatório' }] }}},[_c('a-input',{attrs:{"placeholder":"Quantum","type":"number","min":"1"}})],1)],1)],2),_vm._v(" "),_c('a-modal',{attrs:{"title":_vm.estatisticas.titulo,"visible":_vm.estatisticas.visible},on:{"cancel":_vm.handleCancel}},[_c('template',{slot:"footer"},[_c('a-button',{key:"back",on:{"click":_vm.handleCancel}},[_vm._v(" Voltar ")])],1),_vm._v(" "),_c('h3',[_c('p',[_c('b',[_vm._v(" Throughput: ")]),_vm._v(" "+_vm._s(_vm.estatisticas.throughput)+"ms ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(" Tempo Médio de Espera: ")]),_vm._v(" "+_vm._s(_vm.estatisticas.tempoMedioEspera)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(" Tamanho da Fila de Pronto: ")]),_vm._v(" "+_vm._s(_vm.estatisticas.tamMedioFilaPronto)+" ")]),_vm._v(" "),_c('p',[_c('b',[_vm._v(" Tempo Médio de Resposta: ")]),_vm._v(" "+_vm._s(_vm.estatisticas.tempoMedioResposta)+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_c('b',[_vm._v(" Tempo de Resposta por Processo: ")])]),_vm._v(" "),_vm._l((this[_vm.estatisticas.escalonador].lista_bcp),function(processo){return _c('span',{key:processo.id},[_c('p',[_c('b',[_vm._v(" P"+_vm._s(processo['id'])+": ")]),_vm._v(" "+_vm._s(processo['tempo_resposta'])+" ")])])})],2)],2),_vm._v(" "),_c('a-layout-content',{style:({ margin: '24px 16px', padding: '24px', background: '#fff' })},[_c('a-collapse',{attrs:{"bordered":false}},[_c('a-collapse-panel',{key:"sjf",staticClass:"accordion"},[_c('template',{slot:"header"},[_c('i',[_vm._v(" Shortest Job First ")]),_vm._v("  \n          "),(_vm.sjf.status !== '')?_c('b',[_vm._v(" "+_vm._s(_vm.sjf.clock)+" ")]):_vm._e()]),_vm._v(" "),(_vm.sjf.status !== 'terminado')?_c('a-row',{staticStyle:{"margin-bottom":"10px"}},[(_vm.sjf.status === '')?_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.inicia('sjf')}}},[_c('a-icon',{attrs:{"type":"play-circle"}})],1):(_vm.sjf.status === 'continua')?_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.pausa('sjf')}}},[_c('a-icon',{attrs:{"type":"pause-circle-o"}})],1):_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.inicia('sjf')}}},[_c('a-icon',{attrs:{"type":"play-circle-o"}})],1)],1):_c('a-row',{staticStyle:{"margin-bottom":"10px"}},[_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"danger"},on:{"click":function($event){return _vm.calc_estatisticas('sjf')}}},[_c('a-icon',{attrs:{"type":"area-chart"}})],1)],1),_vm._v(" "),_c('a-row',{attrs:{"gutter":16}},[_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Disco"}},_vm._l((_vm.sjf.lista_bcp),function(processo){return (processo.estado == '')?_c('a-tag',{key:processo.id,attrs:{"color":"blue"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ")])]):_vm._e()}),1)],1),_vm._v(" "),_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Bloqueados por I/O"}},[_c('a-avatar',{attrs:{"slot":"extra","shape":"square"},slot:"extra"},[_vm._v(" - ")]),_vm._v(" "),_vm._l((_vm.sjf.fila_bloqueado),function(processo){return (processo.estado == 'bloqueado')?_c('a-tag',{key:processo.id,attrs:{"color":"gray"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ("+_vm._s(processo['tempo_bloqueado'] - (_vm.sjf.clock - processo['cheg_bloqueado']) + 1)+") ")])]):_vm._e()})],2)],1),_vm._v(" "),_c('a-col',{attrs:{"span":4}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Executando"}},[_c('a-avatar',{style:({ backgroundColor: '#87d068' }),attrs:{"slot":"extra","shape":"square"},slot:"extra"},[_vm._v(" X ")]),_vm._v(" "),(_vm.sjf.executando)?_c('a-tag',{attrs:{"color":"green"}},[_c('b',[_vm._v(" P"+_vm._s(_vm.sjf.executando.id)+" ")])]):_vm._e()],1)],1),_vm._v(" "),_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Prontos/Aptos"}},[_c('a-avatar',{style:({ backgroundColor: '#f56a00' }),attrs:{"slot":"extra","shape":"square"},slot:"extra"}),_vm._v(" "),_vm._l((_vm.sjf.fila_pronto),function(processo){return (processo.estado == 'pronto')?_c('a-tag',{key:processo.id,attrs:{"color":"orange"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ")])]):_vm._e()})],2)],1),_vm._v(" "),_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Terminados"}},_vm._l((_vm.sjf.lista_bcp),function(processo){return (processo.estado == 'terminado')?_c('a-tag',{key:processo.id,attrs:{"color":"purple"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ")])]):_vm._e()}),1)],1)],1),_vm._v(" "),_c('a-row',{staticStyle:{"margin-top":"30px"}},[_c('a-table',{attrs:{"dataSource":_vm.sjf.lista_bcp,"rowKey":"id","scroll":{ x: 1300 }}},[_c('a-table-column',{key:"id",attrs:{"dataIndex":"id","width":"50px","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(text, record){return _c('b',{},[_vm._v(" P"+_vm._s(text)+" ")])}}])}),_vm._v(" "),_c('a-table-column',{key:"1",attrs:{"dataIndex":"id","title":"Escalonador SJF (Execução)"},scopedSlots:_vm._u([{key:"default",fn:function(text, record){return _c('b',{staticClass:"scroller"},_vm._l((record.historico),function(exec,index){return _c('span',{key:record.historico[index]['id']},[(exec === 'p')?_c('a-avatar',{style:({ backgroundColor: '#f56a00' }),attrs:{"shape":"square"}}):(exec === 'b')?_c('a-avatar',{attrs:{"shape":"square"}},[_vm._v(" - ")]):(exec === 'e')?_c('a-avatar',{style:({ backgroundColor: '#87d068' }),attrs:{"shape":"square"}},[_vm._v(" X ")]):_c('a-avatar',{style:({ backgroundColor: 'white' }),attrs:{"shape":"square"}})],1)}),0)}}])})],1)],1)],2),_vm._v(" "),_c('a-collapse-panel',{key:"prio",staticClass:"accordion"},[_c('template',{slot:"header"},[_c('i',[_vm._v(" Prioridade ")]),_vm._v("  \n          "),(_vm.prio.status !== '')?_c('b',[_vm._v(" "+_vm._s(_vm.prio.clock)+" ")]):_vm._e()]),_vm._v(" "),(_vm.prio.status !== 'terminado')?_c('a-row',{staticStyle:{"margin-bottom":"10px"}},[(_vm.prio.status === '')?_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.inicia('prio')}}},[_c('a-icon',{attrs:{"type":"play-circle"}})],1):(_vm.prio.status === 'continua')?_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.pausa('prio')}}},[_c('a-icon',{attrs:{"type":"pause-circle-o"}})],1):_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.inicia('prio')}}},[_c('a-icon',{attrs:{"type":"play-circle-o"}})],1)],1):_c('a-row',{staticStyle:{"margin-bottom":"10px"}},[_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"danger"},on:{"click":function($event){return _vm.calc_estatisticas('prio')}}},[_c('a-icon',{attrs:{"type":"area-chart"}})],1)],1),_vm._v(" "),_c('a-row',{attrs:{"gutter":16}},[_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Disco"}},_vm._l((_vm.prio.lista_bcp),function(processo){return (processo.estado == '')?_c('a-tag',{key:processo.id,attrs:{"color":"blue"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ")])]):_vm._e()}),1)],1),_vm._v(" "),_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Bloqueados por I/O"}},[_c('a-avatar',{attrs:{"slot":"extra","shape":"square"},slot:"extra"},[_vm._v(" - ")]),_vm._v(" "),_vm._l((_vm.prio.fila_bloqueado),function(processo){return (processo.estado == 'bloqueado')?_c('a-tag',{key:processo.id,attrs:{"color":"gray"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ("+_vm._s(processo['tempo_bloqueado'] - (_vm.prio.clock - processo['cheg_bloqueado']) + 1)+") ")])]):_vm._e()})],2)],1),_vm._v(" "),_c('a-col',{attrs:{"span":4}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Executando"}},[_c('a-avatar',{style:({ backgroundColor: '#87d068' }),attrs:{"slot":"extra","shape":"square"},slot:"extra"},[_vm._v(" X ")]),_vm._v(" "),(_vm.prio.executando)?_c('a-tag',{attrs:{"color":"green"}},[_c('b',[_vm._v(" P"+_vm._s(_vm.prio.executando.id)+" ")])]):_vm._e()],1)],1),_vm._v(" "),_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Prontos/Aptos"}},[_c('a-avatar',{style:({ backgroundColor: '#f56a00' }),attrs:{"slot":"extra","shape":"square"},slot:"extra"}),_vm._v(" "),_vm._l((_vm.prio.fila_pronto),function(processo){return (processo.estado == 'pronto')?_c('a-tag',{key:processo.id,attrs:{"color":"orange"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ")])]):_vm._e()})],2)],1),_vm._v(" "),_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Terminados"}},_vm._l((_vm.prio.lista_bcp),function(processo){return (processo.estado == 'terminado')?_c('a-tag',{key:processo.id,attrs:{"color":"purple"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ")])]):_vm._e()}),1)],1)],1),_vm._v(" "),_c('a-row',{staticStyle:{"margin-top":"30px"}},[_c('a-table',{attrs:{"dataSource":_vm.prio.lista_bcp,"rowKey":"id","scroll":{ x: 1300 }}},[_c('a-table-column',{key:"id",attrs:{"dataIndex":"id","width":"50px","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(text, record){return _c('b',{},[_vm._v(" P"+_vm._s(text)+" ")])}}])}),_vm._v(" "),_c('a-table-column',{key:"1",attrs:{"dataIndex":"id","title":"Escalonador por Prioridade (Execução)"},scopedSlots:_vm._u([{key:"default",fn:function(text, record){return _c('b',{staticClass:"scroller"},_vm._l((record.historico),function(exec,index){return _c('span',{key:record.historico[index]['id']},[(exec === 'p')?_c('a-avatar',{style:({ backgroundColor: '#f56a00' }),attrs:{"shape":"square"}}):(exec === 'b')?_c('a-avatar',{attrs:{"shape":"square"}},[_vm._v(" - ")]):(exec === 'e')?_c('a-avatar',{style:({ backgroundColor: '#87d068' }),attrs:{"shape":"square"}},[_vm._v(" X ")]):_c('a-avatar',{style:({ backgroundColor: 'white' }),attrs:{"shape":"square"}})],1)}),0)}}])})],1)],1)],2),_vm._v(" "),_c('a-collapse-panel',{key:"rr",staticClass:"accordion"},[_c('template',{slot:"header"},[_c('i',[_vm._v(" Round-Robin ")]),_vm._v("  \n          "),(_vm.rr.status !== '')?_c('b',[_vm._v(" "+_vm._s(_vm.rr.clock)+" ")]):_vm._e()]),_vm._v(" "),(_vm.rr.status !== 'terminado')?_c('a-row',{staticStyle:{"margin-bottom":"10px"}},[(_vm.rr.status === '')?_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.inicia('rr')}}},[_c('a-icon',{attrs:{"type":"play-circle"}})],1):(_vm.rr.status === 'continua')?_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.pausa('rr')}}},[_c('a-icon',{attrs:{"type":"pause-circle-o"}})],1):_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.inicia('rr')}}},[_c('a-icon',{attrs:{"type":"play-circle-o"}})],1)],1):_c('a-row',{staticStyle:{"margin-bottom":"10px"}},[_c('a-button',{staticStyle:{"width":"100%"},attrs:{"type":"danger"},on:{"click":function($event){return _vm.calc_estatisticas('rr')}}},[_c('a-icon',{attrs:{"type":"area-chart"}})],1)],1),_vm._v(" "),_c('a-row',{attrs:{"gutter":16}},[_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Disco"}},_vm._l((_vm.rr.lista_bcp),function(processo){return (processo.estado == '')?_c('a-tag',{key:processo.id,attrs:{"color":"blue"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ")])]):_vm._e()}),1)],1),_vm._v(" "),_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Bloqueados por I/O"}},[_c('a-avatar',{attrs:{"slot":"extra","shape":"square"},slot:"extra"},[_vm._v(" - ")]),_vm._v(" "),_vm._l((_vm.rr.fila_bloqueado),function(processo){return (processo.estado == 'bloqueado')?_c('a-tag',{key:processo.id,attrs:{"color":"gray"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ("+_vm._s(processo['tempo_bloqueado'] - (_vm.rr.clock - processo['cheg_bloqueado']) + 1)+") ")])]):_vm._e()})],2)],1),_vm._v(" "),_c('a-col',{attrs:{"span":4}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Executando"}},[_c('a-avatar',{style:({ backgroundColor: '#87d068' }),attrs:{"slot":"extra","shape":"square"},slot:"extra"},[_vm._v(" X ")]),_vm._v(" "),(_vm.rr.executando)?_c('a-tag',{attrs:{"color":"green"}},[_c('b',[_vm._v(" P"+_vm._s(_vm.rr.executando.id)+" ")])]):_vm._e()],1)],1),_vm._v(" "),_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Prontos/Aptos"}},[_c('a-avatar',{style:({ backgroundColor: '#f56a00' }),attrs:{"slot":"extra","shape":"square"},slot:"extra"}),_vm._v(" "),_vm._l((_vm.rr.fila_pronto),function(processo){return (processo.estado == 'pronto')?_c('a-tag',{key:processo.id,attrs:{"color":"orange"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ")])]):_vm._e()})],2)],1),_vm._v(" "),_c('a-col',{attrs:{"span":5}},[_c('a-card',{staticStyle:{"width":"100%"},attrs:{"title":"Terminados"}},_vm._l((_vm.rr.lista_bcp),function(processo){return (processo.estado == 'terminado')?_c('a-tag',{key:processo.id,attrs:{"color":"purple"}},[_c('b',[_vm._v(" P"+_vm._s(processo.id)+" ")])]):_vm._e()}),1)],1)],1),_vm._v(" "),_c('a-row',{staticStyle:{"margin-top":"30px"}},[_c('a-table',{attrs:{"dataSource":_vm.rr.lista_bcp,"rowKey":"id","scroll":{ x: 1300 }}},[_c('a-table-column',{key:"id",attrs:{"dataIndex":"id","width":"50px","fixed":"left"},scopedSlots:_vm._u([{key:"default",fn:function(text, record){return _c('b',{},[_vm._v(" P"+_vm._s(text)+" ")])}}])}),_vm._v(" "),_c('a-table-column',{key:"1",attrs:{"dataIndex":"id","title":"Escalonador Round-Robin (Execução)"},scopedSlots:_vm._u([{key:"default",fn:function(text, record){return _c('b',{staticClass:"scroller"},_vm._l((record.historico),function(exec,index){return _c('span',{key:record.historico[index]['id']},[(exec === 'p')?_c('a-avatar',{style:({ backgroundColor: '#f56a00' }),attrs:{"shape":"square"}}):(exec === 'b')?_c('a-avatar',{attrs:{"shape":"square"}},[_vm._v(" - ")]):(exec === 'e')?_c('a-avatar',{style:({ backgroundColor: '#87d068' }),attrs:{"shape":"square"}},[_vm._v(" X ")]):_c('a-avatar',{style:({ backgroundColor: 'white' }),attrs:{"shape":"square"}})],1)}),0)}}])})],1)],1)],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 485:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ant_design_vue__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ant_design_vue_dist_antd_css__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ant_design_vue_dist_antd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ant_design_vue_dist_antd_css__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$message = __WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["Y" /* message */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$notification = __WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["Z" /* notification */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$info = __WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["B" /* Modal */].info;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$success = __WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["B" /* Modal */].success;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$error = __WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["B" /* Modal */].error;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$warning = __WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["B" /* Modal */].warning;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$confirm = __WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["B" /* Modal */].confirm;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["a" /* Affix */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["c" /* Anchor */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["d" /* AutoComplete */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["b" /* Alert */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["e" /* Avatar */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["f" /* BackTop */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["g" /* Badge */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["h" /* Breadcrumb */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["i" /* Button */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["j" /* Calendar */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["k" /* Card */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["p" /* Collapse */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["l" /* Carousel */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["m" /* Cascader */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["n" /* Checkbox */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["o" /* Col */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["q" /* DatePicker */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["r" /* Divider */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["s" /* Dropdown */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["t" /* Form */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["u" /* Icon */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["v" /* Input */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["w" /* InputNumber */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["x" /* Layout */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["y" /* List */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["z" /* LocaleProvider */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["A" /* Menu */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["B" /* Modal */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["C" /* Pagination */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["D" /* Popconfirm */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["E" /* Popover */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["F" /* Progress */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["G" /* Radio */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["H" /* Rate */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["I" /* Row */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["J" /* Select */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["K" /* Slider */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["L" /* Spin */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["M" /* Steps */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["N" /* Switch */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["O" /* Table */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["U" /* Transfer */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["V" /* Tree */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["W" /* TreeSelect */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["P" /* Tabs */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["Q" /* Tag */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["R" /* TimePicker */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["S" /* Timeline */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["T" /* Tooltip */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_ant_design_vue__["X" /* Upload */]);

/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 239,
	"./af.js": 239,
	"./ar": 240,
	"./ar-dz": 241,
	"./ar-dz.js": 241,
	"./ar-kw": 242,
	"./ar-kw.js": 242,
	"./ar-ly": 243,
	"./ar-ly.js": 243,
	"./ar-ma": 244,
	"./ar-ma.js": 244,
	"./ar-sa": 245,
	"./ar-sa.js": 245,
	"./ar-tn": 246,
	"./ar-tn.js": 246,
	"./ar.js": 240,
	"./az": 247,
	"./az.js": 247,
	"./be": 248,
	"./be.js": 248,
	"./bg": 249,
	"./bg.js": 249,
	"./bm": 250,
	"./bm.js": 250,
	"./bn": 251,
	"./bn.js": 251,
	"./bo": 252,
	"./bo.js": 252,
	"./br": 253,
	"./br.js": 253,
	"./bs": 254,
	"./bs.js": 254,
	"./ca": 255,
	"./ca.js": 255,
	"./cs": 256,
	"./cs.js": 256,
	"./cv": 257,
	"./cv.js": 257,
	"./cy": 258,
	"./cy.js": 258,
	"./da": 259,
	"./da.js": 259,
	"./de": 260,
	"./de-at": 261,
	"./de-at.js": 261,
	"./de-ch": 262,
	"./de-ch.js": 262,
	"./de.js": 260,
	"./dv": 263,
	"./dv.js": 263,
	"./el": 264,
	"./el.js": 264,
	"./en-SG": 265,
	"./en-SG.js": 265,
	"./en-au": 266,
	"./en-au.js": 266,
	"./en-ca": 267,
	"./en-ca.js": 267,
	"./en-gb": 268,
	"./en-gb.js": 268,
	"./en-ie": 269,
	"./en-ie.js": 269,
	"./en-il": 270,
	"./en-il.js": 270,
	"./en-nz": 271,
	"./en-nz.js": 271,
	"./eo": 272,
	"./eo.js": 272,
	"./es": 273,
	"./es-do": 274,
	"./es-do.js": 274,
	"./es-us": 275,
	"./es-us.js": 275,
	"./es.js": 273,
	"./et": 276,
	"./et.js": 276,
	"./eu": 277,
	"./eu.js": 277,
	"./fa": 278,
	"./fa.js": 278,
	"./fi": 279,
	"./fi.js": 279,
	"./fo": 280,
	"./fo.js": 280,
	"./fr": 281,
	"./fr-ca": 282,
	"./fr-ca.js": 282,
	"./fr-ch": 283,
	"./fr-ch.js": 283,
	"./fr.js": 281,
	"./fy": 284,
	"./fy.js": 284,
	"./ga": 285,
	"./ga.js": 285,
	"./gd": 286,
	"./gd.js": 286,
	"./gl": 287,
	"./gl.js": 287,
	"./gom-latn": 288,
	"./gom-latn.js": 288,
	"./gu": 289,
	"./gu.js": 289,
	"./he": 290,
	"./he.js": 290,
	"./hi": 291,
	"./hi.js": 291,
	"./hr": 292,
	"./hr.js": 292,
	"./hu": 293,
	"./hu.js": 293,
	"./hy-am": 294,
	"./hy-am.js": 294,
	"./id": 295,
	"./id.js": 295,
	"./is": 296,
	"./is.js": 296,
	"./it": 297,
	"./it-ch": 298,
	"./it-ch.js": 298,
	"./it.js": 297,
	"./ja": 299,
	"./ja.js": 299,
	"./jv": 300,
	"./jv.js": 300,
	"./ka": 301,
	"./ka.js": 301,
	"./kk": 302,
	"./kk.js": 302,
	"./km": 303,
	"./km.js": 303,
	"./kn": 304,
	"./kn.js": 304,
	"./ko": 305,
	"./ko.js": 305,
	"./ku": 306,
	"./ku.js": 306,
	"./ky": 307,
	"./ky.js": 307,
	"./lb": 308,
	"./lb.js": 308,
	"./lo": 309,
	"./lo.js": 309,
	"./lt": 310,
	"./lt.js": 310,
	"./lv": 311,
	"./lv.js": 311,
	"./me": 312,
	"./me.js": 312,
	"./mi": 313,
	"./mi.js": 313,
	"./mk": 314,
	"./mk.js": 314,
	"./ml": 315,
	"./ml.js": 315,
	"./mn": 316,
	"./mn.js": 316,
	"./mr": 317,
	"./mr.js": 317,
	"./ms": 318,
	"./ms-my": 319,
	"./ms-my.js": 319,
	"./ms.js": 318,
	"./mt": 320,
	"./mt.js": 320,
	"./my": 321,
	"./my.js": 321,
	"./nb": 322,
	"./nb.js": 322,
	"./ne": 323,
	"./ne.js": 323,
	"./nl": 324,
	"./nl-be": 325,
	"./nl-be.js": 325,
	"./nl.js": 324,
	"./nn": 326,
	"./nn.js": 326,
	"./pa-in": 327,
	"./pa-in.js": 327,
	"./pl": 328,
	"./pl.js": 328,
	"./pt": 329,
	"./pt-br": 330,
	"./pt-br.js": 330,
	"./pt.js": 329,
	"./ro": 331,
	"./ro.js": 331,
	"./ru": 332,
	"./ru.js": 332,
	"./sd": 333,
	"./sd.js": 333,
	"./se": 334,
	"./se.js": 334,
	"./si": 335,
	"./si.js": 335,
	"./sk": 336,
	"./sk.js": 336,
	"./sl": 337,
	"./sl.js": 337,
	"./sq": 338,
	"./sq.js": 338,
	"./sr": 339,
	"./sr-cyrl": 340,
	"./sr-cyrl.js": 340,
	"./sr.js": 339,
	"./ss": 341,
	"./ss.js": 341,
	"./sv": 342,
	"./sv.js": 342,
	"./sw": 343,
	"./sw.js": 343,
	"./ta": 344,
	"./ta.js": 344,
	"./te": 345,
	"./te.js": 345,
	"./tet": 346,
	"./tet.js": 346,
	"./tg": 347,
	"./tg.js": 347,
	"./th": 348,
	"./th.js": 348,
	"./tl-ph": 349,
	"./tl-ph.js": 349,
	"./tlh": 350,
	"./tlh.js": 350,
	"./tr": 351,
	"./tr.js": 351,
	"./tzl": 352,
	"./tzl.js": 352,
	"./tzm": 353,
	"./tzm-latn": 354,
	"./tzm-latn.js": 354,
	"./tzm.js": 353,
	"./ug-cn": 355,
	"./ug-cn.js": 355,
	"./uk": 356,
	"./uk.js": 356,
	"./ur": 357,
	"./ur.js": 357,
	"./uz": 358,
	"./uz-latn": 359,
	"./uz-latn.js": 359,
	"./uz.js": 358,
	"./vi": 360,
	"./vi.js": 360,
	"./x-pseudo": 361,
	"./x-pseudo.js": 361,
	"./yo": 362,
	"./yo.js": 362,
	"./zh-cn": 363,
	"./zh-cn.js": 363,
	"./zh-hk": 364,
	"./zh-hk.js": 364,
	"./zh-tw": 365,
	"./zh-tw.js": 365
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 630;

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

module.exports = {"_from":"ant-design-vue@^1.1.6","_id":"ant-design-vue@1.3.14","_inBundle":false,"_integrity":"sha512-XJPEjUI8Siu6zZE1wS32gUHSimSDDE70i9gImbCCxyX0GTLf81FDDStreFm6nmb+2JQ307pvDqZSTtAEkwc8bw==","_location":"/ant-design-vue","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"ant-design-vue@^1.1.6","name":"ant-design-vue","escapedName":"ant-design-vue","rawSpec":"^1.1.6","saveSpec":null,"fetchSpec":"^1.1.6"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/ant-design-vue/-/ant-design-vue-1.3.14.tgz","_shasum":"4bef079ec7a74e79a20c5c4fab7b0ab7fb3568fc","_spec":"ant-design-vue@^1.1.6","_where":"C:\\Users\\vitor\\Desktop\\process-scheduling-algorithms","bugs":{"url":"https://github.com/vueComponent/ant-design-vue/issues"},"bundleDependencies":false,"dependencies":{"@ant-design/icons":"^2.1.1","@ant-design/icons-vue":"^2.0.0","add-dom-event-listener":"^1.0.2","array-tree-filter":"^2.1.0","async-validator":"^1.8.2","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-runtime":"6.x","classnames":"^2.2.5","component-classes":"^1.2.6","dom-align":"^1.7.0","dom-closest":"^0.2.0","dom-scroll-into-view":"^1.2.1","enquire.js":"^2.1.6","intersperse":"^1.0.0","is-negative-zero":"^2.0.0","ismobilejs":"^0.5.1","json2mq":"^0.2.0","lodash":"^4.17.5","moment":"^2.21.0","mutationobserver-shim":"^0.3.2","node-emoji":"^1.10.0","omit.js":"^1.0.0","raf":"^3.4.0","resize-observer-polyfill":"^1.5.1","shallow-equal":"^1.0.0","shallowequal":"^1.0.2","vue-ref":"^1.0.4","warning":"^3.0.0"},"deprecated":false,"description":"An enterprise-class UI design language and Vue-based implementation","devDependencies":{"@commitlint/cli":"^6.2.0","@commitlint/config-conventional":"^6.1.3","@octokit/rest":"^15.4.1","@vue/cli-plugin-eslint":"^3.0.5","@vue/server-test-utils":"1.0.0-beta.16","@vue/test-utils":"1.0.0-beta.16","acorn":"^6.0.5","autoprefixer":"^9.6.0","axios":"^0.18.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-eslint":"^10.0.1","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-jest":"^23.6.0","babel-loader":"^7.1.2","babel-plugin-import":"^1.1.1","babel-plugin-inline-import-data-uri":"^1.0.1","babel-plugin-istanbul":"^4.1.1","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-syntax-jsx":"^6.18.0","babel-plugin-transform-class-properties":"^6.24.1","babel-plugin-transform-decorators":"^6.24.1","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-es3-member-expression-literals":"^6.22.0","babel-plugin-transform-es3-property-literals":"^6.22.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-plugin-transform-runtime":"~6.23.0","babel-plugin-transform-vue-jsx":"^3.7.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.6.1","case-sensitive-paths-webpack-plugin":"^2.1.2","chalk":"^2.3.2","cheerio":"^1.0.0-rc.2","codecov":"^3.0.0","colorful":"^2.1.0","commander":"^2.15.0","compare-versions":"^3.3.0","cross-env":"^5.1.4","css-loader":"^0.28.7","deep-assign":"^2.0.0","enquire-js":"^0.2.1","eslint":"^5.8.0","eslint-config-prettier":"^3.0.1","eslint-plugin-html":"^3.2.2","eslint-plugin-vue":"^5.1.0","fetch-jsonp":"^1.1.3","fs-extra":"^7.0.0","glob":"^7.1.2","gulp":"^4.0.1","gulp-babel":"^7.0.0","gulp-strip-code":"^0.1.4","highlight.js":"^9.12.0","html-webpack-plugin":"^3.2.0","husky":"^0.14.3","istanbul-instrumenter-loader":"^3.0.0","jest":"^24.0.0","jest-serializer-vue":"^1.0.0","js-base64":"^2.4.8","jsonp":"^0.2.1","less":"^3.9.0","less-loader":"^4.1.0","less-plugin-npm-import":"^2.1.0","lint-staged":"^7.2.2","markdown-it":"^8.4.0","markdown-it-anchor":"^4.0.0","marked":"^0.3.7","merge2":"^1.2.1","mini-css-extract-plugin":"^0.5.0","minimist":"^1.2.0","mkdirp":"^0.5.1","mockdate":"^2.0.2","nprogress":"^0.2.0","optimize-css-assets-webpack-plugin":"^5.0.1","postcss":"^7.0.6","postcss-loader":"^3.0.0","pre-commit":"^1.2.2","prettier":"^1.15.3","querystring":"^0.2.0","raw-loader":"^1.0.0-beta.0","reqwest":"^2.0.5","rimraf":"^2.6.2","rucksack-css":"^1.0.2","selenium-server":"^3.0.1","semver":"^5.3.0","style-loader":"^0.18.2","stylelint":"^9.10.1","stylelint-config-prettier":"^4.0.0","stylelint-config-standard":"^18.2.0","through2":"^2.0.3","uglifyjs-webpack-plugin":"^2.1.1","url-loader":"^1.1.2","vue":"^2.5.16","vue-antd-md-loader":"^1.1.0","vue-clipboard2":"0.0.8","vue-eslint-parser":"^5.0.0","vue-i18n":"^8.3.2","vue-infinite-scroll":"^2.0.2","vue-jest":"^2.5.0","vue-loader":"^15.5.1","vue-router":"^3.0.1","vue-server-renderer":"^2.5.16","vue-template-compiler":"^2.5.16","vue-virtual-scroller":"^0.12.0","vuex":"^3.1.0","webpack":"^4.28.4","webpack-cli":"^3.2.1","webpack-dev-server":"^3.1.14","webpack-merge":"^4.1.1","webpackbar":"^3.1.5"},"files":["dist","lib","es","types","scripts"],"homepage":"https://vue.ant.design/","keywords":["ant","design","antd","vue","vueComponent","component","components","ui","framework","frontend"],"license":"MIT","main":"lib/index.js","module":"es/index.js","name":"ant-design-vue","peerDependencies":{"vue":">=2.5.0","vue-template-compiler":">=2.5.0"},"pre-commit":["lint","prettier"],"repository":{"type":"git","url":"git+https://github.com/vueComponent/ant-design-vue.git"},"scripts":{"codecov":"codecov","commitmsg":"commitlint -x @commitlint/config-conventional -e $GIT_PARAMS","compile":"node antd-tools/cli/run.js compile","copy":"node scripts/run.js copy-html","dev":"cross-env NODE_ENV=development ENTRY_INDEX=dev ./node_modules/.bin/webpack-dev-server --open --hot --port 3001","dist":"node antd-tools/cli/run.js dist","lint":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./components","lint:style":"stylelint \"{site,components}/**/*.less\" --syntax less","postinstall":"node scripts/postinstall || echo \"ignore\"","pre-publish":"node ./scripts/prepub","prepublish":"node antd-tools/cli/run.js guard","prettier":"node ./scripts/prettier.js","pub":"node antd-tools/cli/run.js pub","pub-with-ci":"node antd-tools/cli/run.js pub-with-ci","site":"node scripts/run.js _site","start":"cross-env NODE_ENV=development ./node_modules/.bin/webpack-dev-server --open --hot","test":"cross-env NODE_ENV=test jest --config .jest.js"},"sideEffects":["site/*","components/style.js","components/**/style/*","*.vue","*.md","dist/*","es/**/style/*","lib/**/style/*","*.less"],"title":"Ant Design Vue","typings":"types/index.d.ts","version":"1.3.14"}

/***/ }),

/***/ 934:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[450]);


// WEBPACK FOOTER //
// static/js/app.fb289fd8eb2085b359e7.js